module.exports = __webpack_public_path__ + "static/media/icon-expand-close.e2467479.svg";